export const HANDLE_ERROR = "HANDLE_ERROR";
export const RESET_ERROR_STATE = "RESET_ERROR_STATE";

const initialState = {
  error: false, 
  errMessage: '',
  color: 'danger'
}
export const errorReducer = ( state = initialState, action ) => {
  switch (action.type) {
    case HANDLE_ERROR:
      return {
        ...state,
        error: true,
        errMessage: action.payload,
      }
  
    case RESET_ERROR_STATE:
      return initialState
  
    default:
      return state
  }
}